import type { CSSProperties, ReactNode, Ref } from 'react';

import { forwardRef } from 'react';
import { styled } from 'styled-components';

import { ContainerSC } from '../../common/Common';
import { BUTTON_MD_INLINE_PADDING } from '../Button';

const ButtonBarSC = styled.nav<{ $position: CSSProperties['position'] }>`
  position: ${(props) => props.$position};
  bottom: 0;
  width: 100%;
  z-index: 3;
  background-color: ${(props) => props.theme.colors.oxfordBlue[100]};
`;

const ButtonContainer = styled(ContainerSC)`
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: flex-end;
  padding-inline: 0;

  @media (min-width: ${(props) => props.theme.devices.laptop}) {
    padding-inline: 1rem;
  }
`;

const ButtonGroupSC = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;

  > button {
    flex-basis: 33%;
    flex-grow: 1;
    padding-inline: 0.25rem;
  }

  @media (min-width: ${(props) => props.theme.devices.laptop}) {
    > button {
      flex-basis: auto;
      flex-grow: 0;
      padding-inline: ${BUTTON_MD_INLINE_PADDING};
    }
  }
`;

type Props = {
  children: ReactNode;
  className?: string;
  position?: CSSProperties['position'];
};

export const ButtonBar = forwardRef(({ children, className, position = 'fixed' }: Props, ref: Ref<HTMLElement>) => {
  return (
    <ButtonBarSC ref={ref} $position={position} className={className}>
      <ButtonContainer>
        <ButtonGroupSC>{children}</ButtonGroupSC>
      </ButtonContainer>
    </ButtonBarSC>
  );
});
